export enum ProductErrorType {
  ProductNotFoundException = 'ProductNotFoundException',
}
